import React from 'react';

const BellIcon = () => (
  <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.0008 7.91886C20.0495 5.16006 22.2185 3 25 3C27.7815 3 29.9505 5.16006 29.9992 7.91886C35.8107 9.95528 40.0001 15.5766 40.0001 22.0773V32.3015L44 36.3197V39.1545C44 40.2591 43.1046 41.1545 42 41.1545H30.9999V41.1636C30.9999 44.4696 28.3134 47.1818 25 47.1818C21.6866 47.1818 19 44.4697 19 41.1636V41.1545H8C6.89543 41.1545 6 40.2591 6 39.1545V36.3197L9.99993 32.3015V22.0773C9.99993 15.5767 14.1892 9.95527 20.0008 7.91886ZM25 7C24.4129 7 24 7.40174 24 8.01364V11.0134L22.4467 11.3694C17.6493 12.4687 13.9999 16.8882 13.9999 22.0773V33.953L10.813 37.1545H39.187L36.0001 33.953V22.0773C36.0001 16.8882 32.3506 12.4687 27.5533 11.3694L26 11.0134V8.01364C26 7.40174 25.5871 7 25 7Z'
      fill='#062471'
    />
  </svg>
);

export default BellIcon;
